// Лимиты загрузки вложений (общие для feedback и предложения мерча)
export const ATTACHMENTS_MAX_FILE_SIZE = 5 * 1024 * 1024 // 5 МБ
export const ATTACHMENTS_MAX_COUNT = 5
